import { createContext, useContext, useEffect, useState, useCallback } from "react";

const SponsorContext = createContext(undefined);

export function SponsorProvider({ children }) {
  const [sponsor, setSponsor] = useState(null);

  /* ------------------------------------------------------------------ */
  /* Restore sponsor                                                     */
  /* ------------------------------------------------------------------ */
  useEffect(() => {
    const stored = localStorage.getItem("jangcoin-sponsor");
    if (stored) setSponsor(stored);
  }, []);

  const updateSponsor = useCallback((value) => {
    if (typeof value !== "string") return;

    const clean = value.trim();
    if (!clean) return;

    localStorage.setItem("jangcoin-sponsor", clean);
    setSponsor(clean);
  }, []);

  const clearSponsor = useCallback(() => {
    localStorage.removeItem("jangcoin-sponsor");
    setSponsor(null);
  }, []);

  return (
    <SponsorContext.Provider
      value={{ sponsor, setSponsor: updateSponsor, clearSponsor }}
    >
      {children}
    </SponsorContext.Provider>
  );
}

export function useSponsor() {
  const ctx = useContext(SponsorContext);
  if (ctx === undefined) {
    throw new Error("useSponsor must be used within SponsorProvider");
  }
  return ctx;
}
